export default __webpack_public_path__ + "static/media/icon_system_on.767a60b4.svg";